import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate"]

  setQuickDate(event) {
    const range = event.currentTarget.dataset.range
    const today = new Date()
    let start = new Date()

    if (range === "today") {
      start = today
    } else if (range === "yesterday") {
      start.setDate(today.getDate() - 1)
      this.startDateTarget.value = this._formatDate(start)
      this.endDateTarget.value = this._formatDate(start)
      return
    } else {
      start.setDate(today.getDate() - parseInt(range, 10))
    }

    this.startDateTarget.value = this._formatDate(start)
    this.endDateTarget.value = this._formatDate(today)
  }

  reset() {
    window.location.href = this.element.dataset.resetUrl
  }

  _formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }
}
